import { css } from 'emotion'
import { TEXT_COLOR_LIGHT, TEXT_COLOR } from 'constants/styleConstants'

export const MemberCardStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;

  .avatarDisplayName {
    display: flex;

    .displayName {
      margin-left: 8px;
      font-weight: bold;
    }

    .email {
      margin: 8px;
    }
  }

  .editButton {
    font-size: 1.25em;

    color: ${TEXT_COLOR_LIGHT};

    &:hover {
      color: ${TEXT_COLOR};
    }
  }

  .roleType {
    margin-top: 4px;
    font-style: italic;
  }
`
